<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <div class="header-nav-con">
         <!-- 导航logo -->
        <div class="header-nav-logo">
          <a href="/">
            <img src="@/assets/img/tap_logo.png">
          </a>
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
          >
            <router-link :to="item.path">
              {{item.name}}
              <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length>0">
              <dt v-for="(i,n) in item.children" :key="n" :class="n == $store.getters.getInformationIndex && $route.path == item.path ? 'active' : ''"  @click.stop="goNav(n, item.path)">{{ i.name }}
                <!-- <span>{{ i.name }}</span> -->
                <!-- <router-link :to="i.path">{{i.name}}</router-link> -->
              </dt>
            </dl>
          </li>
        </ul>
        </div>
    </div>
    <div class="header-banner" v-if="bgUrl">
      <img class="wow" :src="require(`@/assets/img/${$h5 ? 'mobile_'+ bgUrl : bgUrl}`)" alt="logo">
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
      </div> -->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <!-- {{menuName}} -->
        <!-- <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div> -->
        <!-- 导航内容 -->
        <div class="nav_title container">
          <img src="../assets/img/tap_logo.png" alt="">
          <!-- <span>{{ menuName }}</span> -->
          <i :class="menuClass" data-toggle="collapse" data-target="#menu"  @click="menuClick"></i>
        </div>
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path" :class="index==navIndex?'active':''">
              {{item.name}}
              <i class="underline" ></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: {
    bgUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "el-icon-arrow-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        // {
        //   name: "软件产品",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "智能小镇管理系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "大数据管理系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        {
          name: "信息预警",
          path: "/informationwarning",
          children: [
            {
              name: "预警提醒",
              path: "/software/smartTown"
            },
            {
              name: "安全快讯",
              path: "/software/bigData"
            },
            {
              name: "风险前瞻",
              path: "/software/smartTown"
            },
            {
              name: "安全报告",
              path: "/software/bigData"
            }
          ]
        },
        {
          name: "海外安全",
          path: "/overseassecurity",
          children: [
            {
              name: "政府解决方案",
              path: ""
            },
            {
              name: "企业解决方案",
              path: ""
            },
            {
              name: "海外安全服务",
              path: ""
            },
            {
              name: "海外安全APP",
              path: ""
            },
            {
              name: "智能穿戴设备",
              path: ""
            },
            {
              name: "服务案例",
              path: ""
            },
          ]
        },
        {
          name: "商贸服务",
          path: "/investmentcommerce",
          children: []
        },
        {
          name: "海外社群",
          path: "/overseascommunities",
          children: []
        },
        {
          name: "关于我们",
          path: "/aboutus",
          children: []
        }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.$store.dispatch('setInformationIndexAsync', {informationIndex: 0})
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "el-icon-arrow-down") {
        this.menuClass = "el-icon-arrow-up";
      } else {
        this.menuClass = "el-icon-arrow-down";
      }
    },
    goNav(index, path) {
      this.$store.dispatch('setInformationIndexAsync', {informationIndex: index})
      this.$router.push(path)
    }
  },
  mounted() {
    setTimeout(()=>{
        this.navList.map((item,index)=>{
          // 预警详情和快讯详情时菜单栏的选中状态
          if(item.path == '/informationwarning' &&( this.$route.path == '/warningdetails' || this.$route.path == '/safetynewsdetails')){
            this.navIndex = index
          }
        })
    }, 200)
  },
  watch: {
    '$route.path'(){
      this.navList.map((item,index)=>{
        if(item.path == this.$route.path){
          this.navIndex = index
        }
      })
    }
  },
};
</script>
<style scoped lang="scss">
/* 顶部 */
#header {
  /* background: rgba(0,0,0,.6); */
  /* border-bottom: 1px solid rgba(255,255,255,.6); */
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  position: absolute;
  height: 70px;
  width: 100%;
  border-bottom: 1px solid rgba(255,255,255,.6);
  background: rgba(0,0,0,.3);
  z-index: 9999;
}
.header-nav-con {
  width: 1170px;
  height: 70px;
  margin: auto;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 125px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
  /* height: 45px; */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 70px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 69px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 18px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #FFFFFF;
  font-size: 16px;
  /* font-weight: bold; */
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -11px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #FFFFFF;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #FFFFFF;
  /* font-size: 18px; */
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  /* bottom: -11px; */
  left: 0;
  bottom: -2px;
  /* text-decoration: none; */
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  padding-bottom: 23px;
  border-bottom: 2px solid #FFFFFF;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 120px;
  top: 80%;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px;
  z-index: 999999;
  text-align: center;
  background: #DFE6ED;
  box-shadow: 0px 0px 6px rgba(0,21,47,0.59);
}
#header .header-nav .header-nav-wrapper > li > dl a {
  color: #4E4E4E;
  font-weight: 400;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  font-weight: 400;
  /* color: #4E4E4E; */
  /* border-bottom: 1px solid #ccc; */
}
#header .header-nav .header-nav-wrapper > li > dl > dt.active {
  font-weight: bold;
  color:#00387D;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #FFFFFF;
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover, #header .header-nav .header-nav-wrapper > li > dl > dt:hover a {
  cursor: pointer;
  color: #FFFFFF;
  background: #00387D;
}

/* 新增banner样式 */
.header-banner {
  /* height: 470px; */
  width: 100%;
  height: auto;
  /* background: red; */
  overflow: hidden;
}
.header-banner img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
.header-banner img:hover {
  transform: scale(1.1);
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999999;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    width: 100%;
    height: 46px;
    font-size: 20px;
    line-height: 46px;
    background: rgba(0,0,0,.3);
    position: relative;
    .nav_title {
      // width: 100%;
      height: 100%;
      position: relative;
      img {
        display: inline-block;
        height: 50%;
        position: absolute;
        left: 0;
        transform: translateY(50%);
      }
      i {
        position: absolute;
        right: 0;
        transform: translateY(70%);
      }
    }
    
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #333;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 46px;
    left: 0;
    width: 100%;
    /* background: #474747; */
    background: #fff;
    box-shadow: 0 0 8px rgba(10,49,110,.4);
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 46px;
    line-height: 46px;
    /* border-bottom: 1px solid #ccc; */
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #333;
    font-size: 16px;
    display: inline-block;
    height: 100%;
    width: 100%;
    position: relative;
    text-decoration: none;
  }
  #header .header-nav-m .header-nav-m-wrapper > li > a.active {
    font-weight: bold;
    color:#00387D;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue